import React from 'react'
import _ from 'lodash'

import {Table, AddressEncoder} from 'ui'
import {DevicesStorage} from 'storage/Device.jsx'

import {SortTypes, LinkCell} from 'ui/Table.jsx'
export {SortTypes}

export class DeviceTable extends React.Component {
   static get propTypes() {
      return {
         params:         React.PropTypes.object.isRequired,
         rescan:         React.PropTypes.any,
         filter:         React.PropTypes.func,
         columns:        React.PropTypes.array.isRequired,
         onToggleColumn: React.PropTypes.func,
         onSortChange:   React.PropTypes.func,
         sorting:        React.PropTypes.array
      }
   }

   static get RewriteStorage() {
      return ({devices, children, sorting, ...props}) => {
         let field = 'meta.updated',
            order = SortTypes.DEFAULT

         if (sorting) {
            [field, order] = sorting
         }

         return React.cloneElement(children, {
            ...props,
            rows: _.sortByOrder(devices, [field], [order.toLowerCase()])
         })
      }
   }

   static colDef(field) {
      switch (field) {
         case 'network':
            return {
               field,
               name:    'Network',
               visible: true,
               cell:    LinkCell,
               link:    ({network}) => `/dashboard/network/${network}/overview`
            }
         case 'key':
            return {
               field,
               name:    'Key',
               visible: true,
               cell:    LinkCell,
               link:    ({network, key}) => `/dashboard/device/${network}/${key}`
            }
         case 'name':
            return {
               field,
               name:         'Name',
               defaultValue: 'Unnamed Device',
               visible:      true,
               cell:         LinkCell,
               link:         ({network, key}) => `/dashboard/device/${network}/${key}`
            }
         case 'address':
            return {field, name: 'Address', visible: true, transform: AddressEncoder.encode}
         case 'type':
            return {field, name: 'Type', visible: true}
         case 'provisioned':
            return {field, name: 'Provisioning', visible: true}

         case 'proto/tm.hardware':
            return {field, name: 'Hardware Vsn', visible: true}
         case 'proto/tm.firmware':
            return {field, name: 'Firmware Vsn', visible: true}
         case 'proto/tm.part':
            return {field, name: 'Part #', visible: true}

         case '*/alive?':
            return {field, name: 'Connected', visible: true}
         case 'meta.chan/connected':
            return {field, name: 'Connected At', visible: true}
         case 'meta.chan/disconnected':
            return {field, name: 'Disconnected', visible: true}
         case 'meta.created':
            return {field, name: 'Created At', visible: true}
         case 'meta.updated':
            return {field, name: 'Updated At', visible: true}
         case 'meta.event/date':
            return {field, name: 'Last Event At', visible: true}
         case 'meta.event/key':
            return {field, name: 'Last Event', visible: true}

         default:
            return {field, name: 'field', visible: true}
      }
   }

   render() {
      const {rescan, params, filter, columns, onSortChange, onToggleColumn, sorting} = this.props,
         colMap = _.map(columns, DeviceTable.colDef)

      return (
         <DevicesStorage filter={filter} nid={params.nid}>
            <DeviceTable.RewriteStorage sorting={sorting}>
               <Table
                  rows={[]}
                  columns={colMap}
                  redraw={rescan}
                  onToggleColumn={onToggleColumn}
                  onSortChange={onSortChange}
                  sorting={sorting}
               />
            </DeviceTable.RewriteStorage>
         </DevicesStorage>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/device-manager/DeviceTable.jsx